import SelectEmployeeFromOffice from "@components/SelectEmployeeFromOffice";
import { PasswordReset } from "./components";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
const ResetPassword = () => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number>();
  const methods = useForm();
  const getSelectedEmployeeId = (id: number | undefined) => {
    setSelectedEmployeeId(id);
  };
  return (
    <div>
      <FormProvider {...methods}>
        <SelectEmployeeFromOffice
          getSelectedEmployeeId={getSelectedEmployeeId}
        />
        <PasswordReset
          employeeId={selectedEmployeeId}
          setSelectedEmployeeId={setSelectedEmployeeId}
        />
      </FormProvider>
    </div>
  );
};

export default ResetPassword;
